import { gsap } from "gsap/gsap-core";
import { CSSPlugin } from 'gsap/CSSPlugin'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollSmoother } from "@rowinski/rwn-assets/src/js/custom/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Collapse } from 'bootstrap';

export class Smoother {
    constructor(config) {
        gsap.registerPlugin(CSSPlugin)
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(ScrollSmoother);
        gsap.registerPlugin(ScrollToPlugin);

        ScrollSmoother.create(config);

        let loadUrlHash = window.location.href.split("#")[1];

        let loadElement = document.querySelector("#" + loadUrlHash);

        if (loadUrlHash && loadElement) {
            setTimeout(function () {
                gsap.to(window, {scrollTo: {y: loadElement, autoKill: false , offsetY: 64}, duration: 0, ease: "power2.inOut"});
            }, 100);
        }

        document.querySelectorAll("a").forEach(element => {
            element.addEventListener('click', function (event) {
                // Make sure this.hash has a value before overriding default behavior
                if (this.hash !== "" && window.location.pathname === this.pathname) {
                    // Prevent default anchor click behavior
                    event.preventDefault();

                    // Store hash
                    let hash = this.hash;

                    let anchorElement = document.querySelector("[class*='" + hash.replace('#', 'anchor-') + "']");
                    let element = document.querySelector(hash);

                    if (element) {
                        if (element.classList.contains('collapse')) {
                            if (!element.classList.contains('show')) {
                                const collapse = new Collapse(element, {
                                    show: true
                                })
                            }
                        }
                    }

                    if (anchorElement) {
                        let anchorElementClassName = Array.from(anchorElement.classList).filter(className => className.includes(hash.replace('#', 'anchor-'))).shift();

                        if (anchorElementClassName && anchorElementClassName.includes('offset-')) {
                            let offset = anchorElementClassName.replace(hash.replace('#', 'anchor-'), '').replace('-offset-', '');

                            setTimeout(function () {
                                gsap.to(window, {scrollTo: {y: anchorElement, offsetY: offset, autoKill: false}, duration: 1, ease: "power2.inOut"});
                            }, 100);
                        } else {
                            setTimeout(function () {
                                gsap.to(window, {scrollTo: {y: anchorElement, autoKill: false, offsetY: 64}, duration: 1, ease: "power2.inOut"});
                            }, 100);
                        }
                    } else if (element) {
                        setTimeout(function () {
                            gsap.to(window, {scrollTo: {y: element, autoKill: false, offsetY: 64}, duration: 1, ease: "power2.inOut"});
                        }, 100);
                    }
                }
            });
        });
    }
}